import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase, Void } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { GetEmailTemplatesResponse } from './get-email-templates.response';

@Injectable({ providedIn: 'root' })
export class GetEmailTemplatesUseCase extends UseCase<Void, Observable<GetEmailTemplatesResponse>> {
    private _apiRequestService = inject(ApiRequestService);
    private _emailBaseUrl = inject<string>('EMAIL_BACKEND_URL' as any);
    private _getEmailTemplatesUrl = '/admin/getEmailTemplates';

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(): Observable<GetEmailTemplatesResponse> | void {
        return this._apiRequestService.sendRequest<object, GetEmailTemplatesResponse>(
            this._emailBaseUrl,
            {},
            true,
            this._getEmailTemplatesUrl
        );
    }
}
